import { useNavigate, useParams } from 'react-router-dom';
import { FaArrowLeft, FaMapMarkedAlt } from 'react-icons/fa';
import yards from '../assets/yards.json';
import YardLayoutMap from '../components/yard-layout/YardLayoutMap';
import UnavailablePlaceholder from '../components/yard-layout/UnavailablePlaceholder';

export default function YardLayoutPage() {
  const { yardNumber } = useParams();
  const navigate = useNavigate();

  const yardId = Number(yardNumber);
  const yard = yards.find((y) => y.Yard === yardId);

  if (!yard) {
    return (
      <div className="w-full px-4 py-6">
        <div className="bg-red-50 border border-red-200 rounded-lg p-6">
          <h2 className="text-xl font-semibold text-red-800 mb-2">Unknown Yard</h2>
          <p className="text-red-600">Yard {yardNumber} was not found in the facility directory.</p>
          <button
            onClick={() => navigate('/comparative-analytics')}
            className="mt-4 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors flex items-center gap-2"
          >
            <FaArrowLeft />
            Back to Comparative Analytics
          </button>
        </div>
      </div>
    );
  }

  const hasCoords = Number.isFinite(yard.lat) && Number.isFinite(yard.lng);

  return (
    <div className="w-full flex flex-col" style={{ height: 'calc(100vh - 8rem)' }}>
      {/* Header */}
      <div className="px-4 py-4 flex-shrink-0">
        <div className="flex items-center gap-3 mb-1">
          <button
            onClick={() => navigate('/comparative-analytics')}
            className="px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-colors flex items-center gap-2"
          >
            <FaArrowLeft />
            Back to Comparative Analytics
          </button>
          <button
            onClick={() => navigate(`/yard/${yardId}/devices`)}
            className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors flex items-center gap-2"
          >
            View device details
          </button>
        </div>
        <div className="flex items-center gap-2 mt-3">
          <FaMapMarkedAlt className="text-2xl text-blue-600" />
          <h1 className="text-2xl font-bold text-gray-800">
            Yard {yardId} — Layout
          </h1>
          {yard.City && (
            <span className="text-gray-500 text-sm">
              {yard.City}, {yard.State}
            </span>
          )}
        </div>
      </div>

      {/* Map or placeholder — fills remaining height */}
      <div className="flex-1 min-h-0">
        {hasCoords ? (
          <YardLayoutMap yard={yard} />
        ) : (
          <UnavailablePlaceholder yard={yard} reason="no-coords" />
        )}
      </div>
    </div>
  );
}
